import { combineReducers } from 'redux'
import { reducer as dataset } from './dataset'
import { reducer as option } from './option'
import { reducer as preset } from './preset'
import { reducer as language} from './language'
import { connectRouter } from 'connected-react-router';
import auth from "./auth";
import message from "./message";

export default history => combineReducers({
    router: connectRouter(history),
    dataset,
    option,
    preset,
    auth,
    message,
    language
})